"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.parseSearchOptions = void 0;
var _node = require("@domain-group/fe-allhomes-library/lib/node");
var _searchType = require("../enums/search-type");
var getListingTypeKey = input => {
  if (typeof input === 'string') {
    return input;
  }
  if ('name' in input) {
    return input.name;
  }
  var listingType = input.listingType;
  return _node.ListingType[listingType].name || 'SALES_RESIDENTIAL';
};
var parseSearchOptions = input => {
  var listingType = getListingTypeKey(input);
  var searchType = typeof input === 'object' && 'searchType' in input ? input.searchType : _searchType.DefaultSearchType;
  return {
    listingType,
    searchType: (0, _searchType.parseSearchType)(searchType)
  };
};
exports.parseSearchOptions = parseSearchOptions;